import { render, staticRenderFns } from "./RealEstateSuitability.vue?vue&type=template&id=2d45b472&scoped=true&"
import script from "./RealEstateSuitability.vue?vue&type=script&lang=js&"
export * from "./RealEstateSuitability.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateSuitability.vue?vue&type=style&index=0&id=2d45b472&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45b472",
  null
  
)

export default component.exports